export enum businessPartnerManagementRoutes {
  Edit = ':businessPartnerId',
  New = 'new',
  List = 'list',
}
